import { FAIRE_DIRECT_TARGETED_RECURRING_MARKETPLACE_MODAL_240826 } from "@faire/web-api/indigofair/settings/FAIRE_DIRECT_TARGETED_RECURRING_MARKETPLACE_MODAL_240826";

import { useSetting } from "./__internal__/useSetting";

export const useSettingFaireDirectEnableTargetedRecurringMarketplaceModal =
  (): boolean =>
    useSetting(FAIRE_DIRECT_TARGETED_RECURRING_MARKETPLACE_MODAL_240826, false);
